import { ref }         from "vue";
import { useStore }    from "vuex";
import { get as _get } from "lodash-es";

export default function getCopydeck ()
{
    const store = useStore();

    const copydeck = ref( store.state.copydeck );
    const lang     = "fr";

    const handler =
              {
                  get : ( target, name ) =>
                  {
                      let obj = _get( target, name );

                      if ( obj === undefined )
                      {
                          let type = typeof name;

                          if ( type === "symbol" )
                          {
                              //if we have not found something, we check if we can find a localized version
                              let loc = _get( target, lang );

                              if ( loc )
                              {
                                  return () => loc;
                              }
                          }

                          return name;
                      } else if ( typeof obj === "string" )
                      {
                          return obj
                      }

                      if ( typeof obj !== "object" && typeof obj !== "function" )
                      {
                          return obj;

                      }

                      return new Proxy( obj, handler );
                  },


              };

    return new Proxy( copydeck.value, handler );
}


export function scrollToTopOfProfile ()
{

    const profile            = document.querySelector( '#profile' );
    const profilePositionTop = profile.getBoundingClientRect().top + 160;

    window.scroll( {
        top      : 5, // don't make it 0 because, otherwise the sticky header expands and it all looks weird.
        behavior : 'smooth',
    } );

}


export function scrollToFirstError ()
{

    let firstError = document.querySelectorAll( '.error' );

    if ( !firstError )
    {
        return;
    }

    firstError = firstError[ 0 ];

    const firstErrorPositionTop = firstError.getBoundingClientRect().top + 160;

    window.scroll( {
        top      : firstErrorPositionTop,
        behavior : 'smooth',
    } );

}
